import * as React from "react";
import { AllInputProps } from "../../../interfaces/props/AllInputProps";
import { InputFactoryHelper } from "./inputFactoryHelper";

export const InputFactory: React.FunctionComponent<AllInputProps> = props => {
  const factory = new InputFactoryHelper(props);
  return <>{factory.create(props.type)}</>;
};

export default InputFactory;
